<ul class="app-periodical-unit-layout-wrapper">
  <li *ngFor="let item of periodicalService.units">
    <app-document-card [selectable]="periodicalService.adminSelection" [in]="'periodical'" [item]="item"></app-document-card>
  </li>
</ul>